import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Button from '../Button/Button';
import { useTheme } from '../../../../../ThemeContext';

import styles from './ConfirmationForm.module.scss';

type Props = {
  email?: string;
  loggedIn?: boolean;
  onClickResetPassword: () => void;
  isChangePassword?: string;
  title?: string;
  description?: string;
  isShowReset:boolean;
};

const ConfirmationForm: React.FC<Props> = ({ email, onClickResetPassword, loggedIn, isChangePassword, title, description,isShowReset }: Props) => {
  const { t } = useTranslation('account');
  const location = useLocation();
  const { universalStyles } = useTheme();

  return (
    <div className={styles.forgotPasswordForm}>
      <h2 className={styles.title} style={universalStyles.primaryTextColor}>
        {title ? title : t('reset.check_your_inbox')}
      </h2>
      <p className={styles.text}>
        <span style={universalStyles.neutral400}>{description ? description : t('reset.link_sent_text')} </span>
        <span style={universalStyles.primaryTextColor}>{email}</span>
      </p>

      {isShowReset && <Button
        onClick={onClickResetPassword}
        className={styles.button}
        fullWidth
        color="primary"
        size="exlarge"
        label={isChangePassword ? isChangePassword : t('reset.reset_password_button')}
        textStyle={universalStyles.primaryThemeButtonText}
        style={universalStyles.signUpButton}
      />}

      {/* {!loggedIn && (
        <React.Fragment>
          <span className={styles.notSure}>{t('reset.not_sure')}</span>
          <Link className={styles.link} to={modalURLFromLocation(location, 'forgot-password')}>
            {t('reset.try_again')}
          </Link>
        </React.Fragment>
      )} */}
    </div>
  );
};

export default ConfirmationForm;
